import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { get_all_project_file_Api } from "../dashboardapi";
import { setToken } from '../Utils/authUtils';
// import { AbsoluteCenter, Box, Flex, Image, chakra } from "@chakra-ui/react";

const RedirectProject = () => {

    const { projectid } = useParams()
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const searchPriority = [".tex", ".bib", ".txt", ".cls", ".sty", ".pdf"]

    const redirectProject = async () => {
        if (searchParams.get("token") !== null) {
            setToken(searchParams.get("token"));
        }
        let result = await get_all_project_file_Api(projectid);
        try {
            if (result.data) {
                for (var sp of searchPriority) {
                    for (var d of result.data) {
                        if (d.name.toLowerCase().endsWith(sp)) {
                            let redirect = d.name
                            navigate(redirect)
                            return;
                        }
                    }
                }
            } else {
                let error = result.error.message || "An error Occurred"
            }
        } catch (error) {
            alert(error)
        }
    }

    redirectProject()
    return (
        <></>
    );
};

export default RedirectProject;
